import React,{Component} from 'react';
import classnames from 'classnames';

import Greetings from './Greetings';
import BrandPersonalization from './Brand';
import Design from './Design';
import InitialState from './InitialState';
import sample from '../../../assets/images/sample.png'
import Loading from '../../common/Loading';
import './index.scss';
import { func } from 'prop-types';

function accordionData(domain, actioncolor){
  const cutomizationValues = [
    {
      title:'Greeting',
      description:'Customize how you welcome your visitors',
      component: (props,onValueChange,onSave,onCancel,removeLogo,webchatconfig, auth,business)=>{return <Greetings props={props} onValueChange={onValueChange}  onSave={onSave} onCancel={onCancel} auth={auth} business={business} domain={domain} actioncolor={actioncolor}/>}
  
    },
    {
      title:(domain!=='DENTAL')?'Brand personalization':'Personalization',
      description:'Customize your logo and names',
      component: (props,onValueChange,onSave,onCancel,removeLogo,webchatconfig, auth,business)=>{return <BrandPersonalization props={props} onValueChange={onValueChange} onSave={onSave} onCancel={onCancel} removeLogo={removeLogo} webchatconfig={webchatconfig} auth={auth} business={business}/>}
    },
    // {
    //   title:'Require an email for new conversations',
    //   description:'This allows you to get back to your website visitors',
    //   component: (props,onValueChange,onSave,onCancel,removeLogo,webchatconfig, auth)=>{return <Design props={props} onValueChange={onValueChange} onSave={onSave} onCancel={onCancel} auth={auth} />}
    // },
    {
      title:'Initial state',
      description:'Control whether chat window is initially open or closed',
      component: (props,onValueChange,onSave,onCancel,removeLogo,webchatconfig, auth)=>{return <InitialState props={props} onValueChange={onValueChange} onSave={onSave} onCancel={onCancel} auth={auth} />}
    },
  ]
  return cutomizationValues;
}

class ConversationList extends Component {
  
  constructor(props){
    super(props);
    this.state ={
      accordion: -1,
      greetings:'Hi there  How can i help you today?',
      firstmessage:'Welcome!!!',
      file_name:'',
      global_logo_file:'',
      business_name: '',
      assistant_name:'Studio Assiatant',
      actioncolor:'#BB2C2C',
      brandcolor:'#000000',
      require_email:false,
      email_capture_message:'',
      collapse_on_start:true
    }
  }
  componentDidMount =()=>{
    if(this.props.business&& this.props.business.id){
      this.setState({
        business_name:this.props.business.info.BUSINESS_NAME
      })
    }
    if(this.props.webchatconfig.getWebpreference!==true && this.props.webchatconfig.webchatpreference && Object.keys(this.props.webchatconfig.webchatpreference).length !== 0){
      const { webchatpreference } = this.props.webchatconfig;
      const { greeting, brand_personalization, new_conversation_preference, initial_state} = webchatpreference;
      this.setState({
        greetings: (greeting.greeting_message)?greeting.greeting_message:`Hi! 🙂I'm Sasha from ${this.props.business.info.BUSINESS_NAME}. How can I help you today?`,
        firstmessage: (greeting.first_message)?greeting.first_message:`Hello!! Welcome to ${this.props.business.info.BUSINESS_NAME}`,
        global_logo_file:  brand_personalization.global_logo_file,
        file_name: (brand_personalization.file_name)?brand_personalization.file_name:null,
        business_name:  brand_personalization.business_name,
        assistant_name:  brand_personalization.assistant_name,
        actioncolor:  brand_personalization.action_color,
        brandcolor:  brand_personalization.background_color,
        require_email:  (new_conversation_preference.require_email)?new_conversation_preference.require_email:false,
        email_capture_message:  new_conversation_preference.email_capture_message,
        collapse_on_start:  (initial_state.collapse_on_start)?initial_state.collapse_on_start:false,
      })
    }
  }
  componentWillReceiveProps(nextProps){
    if(nextProps.business && nextProps.business.isInfoFetched && nextProps.business.isInfoFetched!==this.props.business.isInfoFetched){
      this.setState({
        business_name:nextProps.business.info.BUSINESS_NAME
      })
    }
    if(nextProps.webchatconfig.getWebpreference!==true && nextProps.webchatconfig.webchatpreference && Object.keys(nextProps.webchatconfig.webchatpreference).length !== 0){
      const { webchatpreference } = nextProps.webchatconfig;
      const { greeting, brand_personalization, new_conversation_preference, initial_state} = webchatpreference;
      this.setState({
        greetings: (greeting.greeting_message)?greeting.greeting_message:`Hi! 🙂I'm Sasha from ${nextProps.business.info.BUSINESS_NAME}. How can I help you today?`,
        firstmessage: (greeting.first_message)?greeting.first_message:`Hello!! Welcome to ${this.props.business.info.BUSINESS_NAME}`,
        global_logo_file:  (brand_personalization.global_logo_file)?brand_personalization.global_logo_file:null,
        file_name: (brand_personalization.file_name)?brand_personalization.file_name:null,
        business_name:  brand_personalization.business_name,
        assistant_name:  brand_personalization.assistant_name,
        actioncolor:  brand_personalization.action_color,
        brandcolor:  brand_personalization.background_color,
        require_email:  (new_conversation_preference.require_email)?new_conversation_preference.require_email:false,
        email_capture_message:  new_conversation_preference.email_capture_message,
        collapse_on_start:  (initial_state.collapse_on_start)?initial_state.collapse_on_start:false,
      })
    }
  }
  openAccordion = (index)=>{
    if(index!==this.state.accordion){
    this.setState({
      accordion:index
    })
    }else{
      this.setState({
        accordion:-1
      })
    }
  }

  onValueChange =(event,target)=>{
    if(target === 'actioncolor'|| target==='brandcolor'){
      this.setState({
        [target]:event.hex
      })
    }else{
    this.setState({
      [target]:event.target.value
    })
    if(target==='collapse_on_start'){
      this.onSave(event,'collapse');
    }
    }
  }
  removeLogo = ()=>{
    this.setState({
      global_logo_file:null,
      file_name:null
    })
  }
  onCancel =()=>{
    const { webchatpreference } = this.props.webchatconfig;
      const { greeting, brand_personalization, new_conversation_preference, initial_state} = webchatpreference;
    this.setState({
        greetings: (greeting.greeting_message)?greeting.greeting_message:`Hi! 🙂I'm Sasha from ${this.props.business.info.BUSINESS_NAME}. How can I help you today?`,
        firstmessage: (greeting.first_message)?greeting.first_message:`Hello!! Welcome to ${this.props.business.info.BUSINESS_NAME}`,
        global_logo_file: (brand_personalization.global_logo_file)?brand_personalization.global_logo_file:null,
        file_name:  (brand_personalization.file_name)?brand_personalization.file_name:null,
        business_name:  brand_personalization.business_name,
        assistant_name:  brand_personalization.assistant_name,
        actioncolor:  brand_personalization.action_color,
        brandcolor:  brand_personalization.background_color,
        require_email:  (new_conversation_preference.require_email)?new_conversation_preference.require_email:false,
        email_capture_message:  new_conversation_preference.email_capture_message,
        collapse_on_start:  (initial_state.collapse_on_start)?initial_state.collapse_on_start:false,
        accordion:-1
    })
  }
  onSave =(event,type)=>{
    console.log(event,type);
    switch(type){
      case 'greetings': this.props.postWebchatGreetings(this.state.greetings,this.state.firstmessage,this.props.business.id,this.props.business.info.EMAIL); break;
      case 'brandings': let params= {
                                    business_name:this.state.business_name,
                                    global_logo_file:this.state.global_logo_file,
                                    file_name:this.state.file_name,
                                    assistant_name:this.state.assistant_name,
                                    action_color:this.state.actioncolor,
                                    background_color:this.state.brandcolor,
                                    };
                        this.props.postWebchatBrandings(params,this.props.business.id,this.props.business.info.EMAIL); break;
      
      case 'email': let param ={
                      require_email:this.state.require_email,
                      email_capture_message:this.state.email_capture_message
                    };
                        this.props.postWebchatEmailPrefs(param,this.props.business.id,this.props.business.info.EMAIL); break;
      case 'collapse': this.props.postWebchatCollapses({collapse_on_start:event.target.value},this.props.business.id,this.props.business.info.EMAIL); break; 
      case 'logo':this.props.postWebchatLogo(event,this.props.business.id,this.props.business.info.EMAIL); break;                 
      default: break;
    }
  }
  render(){
    const {accordion, actioncolor} = this.state;
    const { webchatconfig, auth,business} = this.props;
    
    return (
      accordionData(auth.domain,actioncolor).map((custom,index)=>{
      return (<div key={index}>
              <div className="customization-list" onClick={()=>this.openAccordion(index)}>
                <div className="tabs">
                    <div className={classnames('title',{'selected-accordion': index===accordion})}>{custom.title}</div>
                    <div className="description">{custom.description}</div>
                </div>
                <div className={classnames('acrdn-btn',{'selected-accordion': index===accordion})}><i className="material-icons">keyboard_arrow_down</i></div>
              </div>
              { index===accordion && 
                <>
                {!webchatconfig.getWebGreetings?
                (<div className='accordion-body'>
                  {custom.component(this.state,this.onValueChange , this.onSave, this.onCancel, this.removeLogo, webchatconfig, auth,business)}
                </div>)
                :(
                  <div className="add-campaign_loader">
                  <Loading />
                  </div>
                )
                }
                </>
              } 
              </div>)
      }
      )
    )

  }
};

export default ConversationList;
